import { queryClient } from 'queries';
export const invalidateTaskQuery = async (taskId)=>{
    await queryClient.invalidateQueries({
        predicate: (query)=>{
            return query.queryHash.includes('task-detail') && (query === null || query === void 0 ? void 0 : query.queryHash.includes(taskId.toString()));
        }
    });
};
